import { guides } from '@/mocks/homeData';
import { Link } from 'react-router-dom';

export default function GuidesSection() {
  return (
    <section id="guides" className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Latest <span className="text-primary-600">Basetao Guides</span>
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            In-depth articles and tutorials to help you get the most out of your Basetao Spreadsheet experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {guides.map((guide) => (
            <Link
              key={guide.slug}
              to={guide.slug}
              className="group flex flex-col rounded-2xl bg-background-50 border border-background-200 hover:border-primary-300 hover:shadow-md transition-all duration-200 cursor-pointer overflow-hidden"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={guide.image}
                  alt={guide.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors text-base leading-snug mb-2">
                  {guide.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">{guide.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  Read Article
                  <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}